import CLIENT from '../actionTypes';

import { AppAction } from '../../../types/app';
import { ClientState } from '../types';

const initialState: ClientState = {
  loadReadyStatus: CLIENT.LOAD.INVALID,
  loadErr: null,
  isLoggedIn: false,
  data: undefined,
};

export default (
  state: ClientState = initialState,
  action: AppAction = {}
): ClientState => {
  switch (action.type) {
    case CLIENT.LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        data: null,
      };
    case CLIENT.LOAD.REQUESTING:
      return {
        ...state,
        loadErr: null,
        loadReadyStatus: action.type,
      };
    case CLIENT.LOAD.FAILURE:
      return {
        ...state,
        loadReadyStatus: action.type,
        loadErr: action.err,
      };
    case CLIENT.LOAD.SUCCESS:
      return {
        ...state,
        loadErr: null,
        loadReadyStatus: action.type,
        isLoggedIn: Boolean(action.data?.Id),
        data: action.data,
      };
    case CLIENT.SET_LANG:
      return {
        ...state,
        data: state.data ? { ...state.data, Lang: action.data } : state.data,
      };
    default:
      return state;
  }
};
